import { render, staticRenderFns } from "./Fornecedor.vue?vue&type=template&id=3d07787d"
import script from "./Fornecedor.vue?vue&type=script&lang=js"
export * from "./Fornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports